const ADD_TO_BE_CREATED_TAG = "ADD_TO_BE_CREATED_TAG"
const DELETE_TO_BE_CREATED_TAG = "DELETE_TO_BE_CREATED_TAG"
const CHANGE_NAME_TO_BE_CREATED_TAG = "CHANGE_NAME_TO_BE_CREATED_TAG"
const CHANGE_ORDER_TO_BE_CREATED_TAG = "CHANGE_ORDER_TO_BE_CREATED_TAG"

export {ADD_TO_BE_CREATED_TAG, DELETE_TO_BE_CREATED_TAG, CHANGE_NAME_TO_BE_CREATED_TAG, CHANGE_ORDER_TO_BE_CREATED_TAG}